import { render, staticRenderFns } from "./Kontak.vue?vue&type=template&id=3ed96f1c&scoped=true"
import script from "./Kontak.vue?vue&type=script&lang=js"
export * from "./Kontak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed96f1c",
  null
  
)

export default component.exports